import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
    Login: "[Login] Action",
    Forbidden: "[Forbidden] Action",
    ForbiddenHandled: "[Forbidden Handled] Action",
    PermissionDenied: "[Permission Denied] Action",
    PermissionDeniedHandled: "[Permission Denied Handled] Action",
    Logout: "[Logout] Action",
    UserRequested: "[Request User] Action",
    UserLoaded: "[Load User] Auth API",
    PaymentRequired: "[Payment Required] Action",
    PaymentRegularized: "[Payment Regularized] Action",
};

const initialAuthState = {
    user: undefined,
    authToken: undefined,
    forbidden: false,
    permissionDenied: false,
};

export const reducer = persistReducer({ storage, key: "app-auth", whitelist: ["user", "authToken"] }, (state = initialAuthState, action) => {
    switch (action.type) {
        case actionTypes.Login: {
            return {
                authToken: action.payload.token,
                user: action.payload.user,
            };
        }

        case actionTypes.Logout: {
            routerHelpers.forgotLastLocation();
            return initialAuthState;
        }

        case actionTypes.Forbidden: {
            routerHelpers.forgotLastLocation();
            return { ...initialAuthState, forbidden: true };
        }

        case actionTypes.ForbiddenHandled: {
            return { ...state, forbidden: false };
        }

        case actionTypes.PermissionDenied: {
            return { ...state, permissionDenied: true };
        }

        case actionTypes.PermissionDeniedHandled: {
            return { ...state, permissionDenied: false };
        }

        case actionTypes.PaymentRequired: {
            return state.user ? { ...state, user: { ...state.user, ctm_status: "WAITING_FOR_PAYMENT" } } : state;
        }

        case actionTypes.PaymentRegularized: {
            return state.user ? { ...state, user: { ...state.user, ctm_status: "ENABLED" } } : state;
        }

        case actionTypes.UserLoaded: {
            return {
                ...state,
                user: action.payload.user,
            };
        }

        default:
            return state;
    }
});

export const actions = {
    login: (payload) => ({ type: actionTypes.Login, payload }),
    logout: () => ({ type: actionTypes.Logout }),
    fulfillUser: (payload) => ({ type: actionTypes.UserLoaded, payload }),
    paymentRequired: () => ({ type: actionTypes.PaymentRequired }),
    paymentRegularized: () => ({ type: actionTypes.PaymentRegularized }),
};

export function* saga() { }
